import { useTranslation } from 'react-i18next'

import Select from '@/components/Select/Select'
import type { FormFieldType } from '@/types/form-field-type'

import type { RoomType } from '../constants/room-types'
import { getRoomTypeOptions } from '../utils/get-room-type-options'

const RoomTypeSelect = (props: FormFieldType<RoomType>) => {
  const { t } = useTranslation('rooms')

  const options = getRoomTypeOptions()

  return (
    <Select
      {...props}
      placeholder={t('placeholder.select-type')}
      options={options}
    />
  )
}

export default RoomTypeSelect
